export const Constants = {
    // 公司id  1548210858814631936  1548223800395059200
    // 公司ID 1549220461870383104  1549220461870383105
    id: '1549220461870383105'
    // id:'1549220461870383104'
}